export const generateSectionId = (sectionId: number, prefix = 's') => `${prefix}-${sectionId}`;
